var _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgContactHeroColored(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 317,
    height: 48,
    viewBox: "0 0 317 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.3678 16.9962H32.2989C32.1149 15.7034 31.7395 14.5551 31.1724 13.5513C30.6054 12.5323 29.8774 11.6654 28.9885 10.9506C28.0996 10.2357 27.0728 9.68821 25.908 9.30799C24.7586 8.92776 23.5096 8.73764 22.1609 8.73764C19.7241 8.73764 17.6015 9.3384 15.7931 10.5399C13.9847 11.7262 12.5824 13.4601 11.5862 15.7414C10.59 18.0076 10.092 20.7605 10.092 24C10.092 27.3308 10.59 30.1293 11.5862 32.3954C12.5977 34.6616 14.0077 36.3726 15.8161 37.5285C17.6245 38.6844 19.7165 39.2624 22.092 39.2624C23.4253 39.2624 24.659 39.0875 25.7931 38.7376C26.9425 38.3878 27.9617 37.8783 28.8506 37.2091C29.7395 36.5247 30.4751 35.6958 31.0575 34.7224C31.6552 33.7491 32.069 32.6388 32.2989 31.3916L42.3678 31.4373C42.1073 33.5817 41.4559 35.6502 40.4138 37.6426C39.387 39.6198 38 41.3916 36.2529 42.9582C34.5211 44.5095 32.4521 45.7414 30.046 46.654C27.6552 47.5513 24.9502 48 21.931 48C17.7318 48 13.977 47.057 10.6667 45.1711C7.37165 43.2852 4.76628 40.5551 2.85057 36.981C0.950191 33.4068 0 29.0798 0 24C0 18.9049 0.965517 14.5703 2.89655 10.9962C4.82759 7.42205 7.44828 4.69962 10.7586 2.8289C14.069 0.942966 17.7931 0 21.931 0C24.659 0 27.1877 0.380228 29.5172 1.14068C31.8621 1.90114 33.9387 3.01141 35.7471 4.47148C37.5556 5.91635 39.0268 7.68821 40.1609 9.78707C41.3103 11.8859 42.046 14.289 42.3678 16.9962Z",
    fill: "url(#paint0_radial_710_2163)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M92.7701 24C92.7701 29.0951 91.7969 33.4297 89.8506 37.0038C87.9195 40.5779 85.2835 43.308 81.9425 45.1939C78.6169 47.0646 74.8774 48 70.7241 48C66.5402 48 62.7854 47.057 59.4598 45.1711C56.1341 43.2852 53.5057 40.5551 51.5747 36.981C49.6437 33.4068 48.6782 29.0798 48.6782 24C48.6782 18.9049 49.6437 14.5703 51.5747 10.9962C53.5057 7.42205 56.1341 4.69962 59.4598 2.8289C62.7854 0.942966 66.5402 0 70.7241 0C74.8774 0 78.6169 0.942966 81.9425 2.8289C85.2835 4.69962 87.9195 7.42205 89.8506 10.9962C91.7969 14.5703 92.7701 18.9049 92.7701 24ZM82.6782 24C82.6782 20.6996 82.1801 17.9164 81.1839 15.6502C80.2031 13.384 78.8161 11.6654 77.023 10.4943C75.2299 9.3232 73.1303 8.73764 70.7241 8.73764C68.318 8.73764 66.2184 9.3232 64.4253 10.4943C62.6322 11.6654 61.2375 13.384 60.2414 15.6502C59.2605 17.9164 58.7701 20.6996 58.7701 24C58.7701 27.3004 59.2605 30.0836 60.2414 32.3498C61.2375 34.616 62.6322 36.3346 64.4253 37.5057C66.2184 38.6768 68.318 39.2624 70.7241 39.2624C73.1303 39.2624 75.2299 38.6768 77.023 37.5057C78.8161 36.3346 80.2031 34.616 81.1839 32.3498C82.1801 30.0836 82.6782 27.3004 82.6782 24Z",
    fill: "url(#paint1_radial_710_2163)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M139.523 0.638784V47.3612H130.925L110.443 17.9544H110.098V47.3612H100.144V0.638784H108.879L129.201 30.0228H129.615V0.638784H139.523Z",
    fill: "url(#paint2_radial_710_2163)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M145.954 8.78327V0.638784H184.621V8.78327H170.207V47.3612H160.368V8.78327H145.954Z",
    fill: "url(#paint3_radial_710_2163)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M193.351 47.3612H182.684L198.937 0.638784H211.764L227.994 47.3612H217.328L205.534 11.3156H205.167L193.351 47.3612ZM192.684 28.9962H217.879V36.7072H192.684V28.9962Z",
    fill: "url(#paint4_radial_710_2163)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M272.989 16.9962H262.92C262.736 15.7034 262.36 14.5551 261.793 13.5513C261.226 12.5323 260.498 11.6654 259.609 10.9506C258.72 10.2357 257.693 9.68821 256.529 9.30799C255.379 8.92776 254.13 8.73764 252.782 8.73764C250.345 8.73764 248.222 9.3384 246.414 10.5399C244.605 11.7262 243.203 13.4601 242.207 15.7414C241.211 18.0076 240.713 20.7605 240.713 24C240.713 27.3308 241.211 30.1293 242.207 32.3954C243.218 34.6616 244.628 36.3726 246.437 37.5285C248.245 38.6844 250.337 39.2624 252.713 39.2624C254.046 39.2624 255.28 39.0875 256.414 38.7376C257.563 38.3878 258.582 37.8783 259.471 37.2091C260.36 36.5247 261.096 35.6958 261.678 34.7224C262.276 33.7491 262.69 32.6388 262.92 31.3916L272.989 31.4373C272.728 33.5817 272.077 35.6502 271.034 37.6426C270.008 39.6198 268.621 41.3916 266.874 42.9582C265.142 44.5095 263.073 45.7414 260.667 46.654C258.276 47.5513 255.571 48 252.552 48C248.352 48 244.598 47.057 241.287 45.1711C237.992 43.2852 235.387 40.5551 233.471 36.981C231.571 33.4068 230.621 29.0798 230.621 24C230.621 18.9049 231.586 14.5703 233.517 10.9962C235.448 7.42205 238.069 4.69962 241.379 2.8289C244.69 0.942966 248.414 0 252.552 0C255.28 0 257.808 0.380228 260.138 1.14068C262.483 1.90114 264.559 3.01141 266.368 4.47148C268.176 5.91635 269.648 7.68821 270.782 9.78707C271.931 11.8859 272.667 14.289 272.989 16.9962Z",
    fill: "url(#paint5_radial_710_2163)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M278.333 8.78327V0.638784H317V8.78327H302.586V47.3612H292.747V8.78327H278.333Z",
    fill: "url(#paint6_radial_710_2163)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_710_2163",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-14.5665 78.7499) rotate(-16.4384) scale(382.497 4553.13)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4DB5F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F04DC2"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_710_2163",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-14.5665 78.7499) rotate(-16.4384) scale(382.497 4553.13)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4DB5F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F04DC2"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_710_2163",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-14.5665 78.7499) rotate(-16.4384) scale(382.497 4553.13)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4DB5F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F04DC2"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_710_2163",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-14.5665 78.7499) rotate(-16.4384) scale(382.497 4553.13)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4DB5F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F04DC2"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_710_2163",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-14.5665 78.7499) rotate(-16.4384) scale(382.497 4553.13)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4DB5F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F04DC2"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_710_2163",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-14.5665 78.7499) rotate(-16.4384) scale(382.497 4553.13)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4DB5F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F04DC2"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_710_2163",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-14.5665 78.7499) rotate(-16.4384) scale(382.497 4553.13)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4DB5F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F04DC2"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactHeroColored);
export default __webpack_public_path__ + "static/media/contact_hero_colored.0a67a9689a919d4203e0278a93289b69.svg";
export { ForwardRef as ReactComponent };